import HCLDX from "@system/config/hcldx";
import System from "src/helper/system";
const c = System.getParams();

class Cart {
// Guest User
static GUEST_CART_COUNT = System.getCartUrl() + "/api/cart/guest/Count";
static GUEST_CART_VIEW = System.getCartUrl() + "/api/cart/guest/shoppingCart";
static GUEST_ADD_TO_CART= System.getCartUrl() + "/api/cart/guest/addItem";
static GUEST_MERGE_CART_ITEMS= System.getCartUrl() + "/api/cart/guest/mergeCartItems";
static GUEST_ADD_TO_CART_IN_BULK = System.getCartUrl() + "/api/cart/guest/addItems";

// Web & Core User
  static CART_COUNT = System.getCartUrl() + "/api/cart/count";
  static ADD_TO_CART = System.getCartUrl() + "/api/cart/addItem";
  static ADD_TO_CART_IN_BULK = System.getCartUrl() + "/api/cart/addItems";
  static UPDATE_TO_CART = System.getCartUrl() + "/api/cart/update";
  static UPDATE_BACKORDER_QUANTITY_TO_CART = System.getCartUrl() + "/api/cart/orderItemUpdate";
  static VIEW_CART = System.getCartUrl() + "/api/cart/shoppingCart";
  static VALIDATE_CART = System.getCartUrl() + "/api/cart/validateCart";
  static COMPLETELY_CLEAR_CART = System.getCartUrl() + "/api/cart/clear";
  static CLEAR_SINGLE_PRODUCT_FROM_CART = System.getCartUrl() + "/api/cart/deleteItem";
  static SCHEDULE_SHIPPING_APPLY = System.getCartUrl() + "/api/scheduleShipping/apply";
  static EXPORT_CART_DATA = System.getCartUrl() + "/api/cart/exportCart";
  static VALIDATE_TO_SHIP = System.getApplicationUrl() + "/api/application/validatetoship";
  static CHECK_CART_ITEM_EXIST = System.getCartUrl() + "/api/cart/checkItemsExists";
  static REPLACE_TO_CART_IN_BULK = System.getCartUrl() + "/api/cart/moveToCart";
  static SHIPPING_ADDRESS = System.getBaseUrl() + `/api/user/shippingAddress`;
  static CUSTOMER_SCOPED_INFORMATION = System.getBaseUrl() + '/api/customer/details';
  static SCHEDULE_SHIPPING_VIEW = System.getCartUrl() + "/api/scheduleShipping/view";
  static ADD_COMPLIANCE_DATA = System.getCartUrl() + "/api/order/amer/exportCompliance";
  static GET_COMPLIANCE_DATA = System.getApplicationUrl() + "/api/application/exportComliance/form";
  static CART_CALCULATE_TAX = System.getCartUrl() + "/api/order/calculateTax";
  static GET_PAYMENT_TOKEN = System.getCartUrl() + "/api/paymentmethod/getpaymetrictoken";
  
  static UPDATE_CART_ITEMS_BULK = System.getCartUrl() + '/api/cart/updateitems';
  
  static getCartPageRouteURL() {
    return HCLDX.baseURL() + '/shop/cart';
  }

  static getQuoteCartPageRouteURL() {
    return HCLDX.baseURL() + "/shop/quote-cart";
  }

  static getCartPagePlainRouteURL() {
    return "/shop/cart";
  }
}

export default Cart;
